import styled from 'styled-components';

export const CommunicationSC = styled.div`
  display: flex;
  flex: 1;
  align-items: stretch;
`;

export const MessagesColSC = styled.div`
  flex-grow: 1;
  border-right: 2px solid #fff;
`;

export const GroupsColSC = styled.div`
  min-width: 33.333%;
`;
